import React from 'react';
import { DivLine } from '../../styledComponents/StyledComponents';
import { TranslatedMessage } from '../../translation';
import { TLCode } from '../../../../common/enums';
import styled from '@emotion/styled';

const GreenSpan = styled.span`
  background-color: LightGreen;
`;
const RedSpan = styled.span`
  background-color: Coral;
`;

export interface BlackPointCountersProps {
  blackPointHolidayCount: number;
  blackPointHolidayMax: number;
  blackPointEconomicMax: number;
  annualFreeBankHolidayMax: number;
  blackPointOnBankHolidayCount: number;
  annualFreeWeekendMax: number;
  blackPointOnWeekendCount: number;
  blackPointEconomicCount: number;
  showEconomicCounters: boolean;
}

export const BlackPointCounters = ({
  blackPointHolidayCount,
  blackPointHolidayMax,
  blackPointEconomicCount,
  blackPointEconomicMax,
  annualFreeBankHolidayMax,
  annualFreeWeekendMax,
  blackPointOnBankHolidayCount,
  blackPointOnWeekendCount,
  showEconomicCounters,
}: BlackPointCountersProps) => {
  return (
    <DivLine style={{ flexWrap: 'wrap' }}>
      <h4>
        <TranslatedMessage id={TLCode.MULTI_CALENDAR_TOOLBOX_NrBlackPoint} />
      </h4>
      &nbsp;
      <p>
        {blackPointHolidayMax - blackPointHolidayCount > 0 ? (
          <GreenSpan>&nbsp;{blackPointHolidayMax - blackPointHolidayCount}&nbsp;</GreenSpan>
        ) : (
          <RedSpan>&nbsp;{blackPointHolidayMax - blackPointHolidayCount}&nbsp;</RedSpan>
        )}
        &nbsp;&nbsp;utilisés: {blackPointHolidayCount} (max {blackPointHolidayMax}) &nbsp;
        <TranslatedMessage id={TLCode.MULTI_CALENDAR_TOOLBOX_NrFreeBankHolidayBalance} />
        {annualFreeBankHolidayMax - blackPointOnBankHolidayCount > 0 ? (
          <span>&nbsp;{blackPointOnBankHolidayCount}</span>
        ) : (
          <RedSpan>&nbsp;{blackPointOnBankHolidayCount}&nbsp;</RedSpan>
        )}
        &nbsp;(max {annualFreeBankHolidayMax}) &nbsp;
        <TranslatedMessage id={TLCode.MULTI_CALENDAR_TOOLBOX_NrFreeWeekendBalance} />
        {annualFreeWeekendMax - blackPointOnWeekendCount > 0 ? (
          <span>&nbsp;{blackPointOnWeekendCount}</span>
        ) : (
          <RedSpan>&nbsp;{blackPointOnWeekendCount}&nbsp;</RedSpan>
        )}
        &nbsp;(max {annualFreeWeekendMax})
      </p>
      {showEconomicCounters && (
        <p>
          &nbsp;&nbsp;&nbsp;
          <TranslatedMessage id={TLCode.MULTI_CALENDAR_TOOLBOX_NrFreeEconomicBlackpoint} />
          &nbsp;{blackPointEconomicCount} (max: {blackPointEconomicMax})
        </p>
      )}
    </DivLine>
  );
};
